import { lazy, Suspense } from 'react';

import { FeedLayout } from 'shared/components/layouts';
import { SearchProvider } from 'shared/features/search';
import { SUPPORTERS } from 'shared/constants';
import { FeedSkeleton } from 'shared/components/ui';

const CommunitySidebar = lazy(() => import('shared/features/community-sidebar'));
const DiscountsContent = lazy(() => import('../components/DiscountsContent'));

export const DiscountsPage = () => {
  return (
    <SearchProvider>
      <FeedLayout
        sidebar={
          <Suspense fallback={<FeedSkeleton />}>
            <CommunitySidebar items={[SUPPORTERS]} />
          </Suspense>
        }
      >
        <Suspense fallback={<FeedSkeleton />}>
          <DiscountsContent />
        </Suspense>
      </FeedLayout>
    </SearchProvider>
  );
};
